/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".light-blue-backdrop[_ngcontent-%COMP%] {\n  background-color: #5cb3fd; }"];
export { styles as styles };
